import React, { useEffect, useState } from "react";
import { useAddInStore, useTokenStore } from "../../../hooks";
import { logger } from "../../../utils";
import { Space } from "../../../models";
import { makeStyles, Select } from "@fluentui/react-components";
import { supabaseApi } from "../../../services";
import { useOfficeItem } from "../../../providers";

const useStyles = makeStyles({
  section: {
    display: "flex",
    flexDirection: "column",
    padding: "15px",
  },
  select: {
    marginTop: "4px",
    width: "100%",
  },
});

export interface SpaceSelectListProps {
  disabled?: boolean;
}

export const SpaceSelectList = ({ disabled = false }: SpaceSelectListProps) => {
  // used to control component styles
  const styles = useStyles();

  // indicates the current event and function to update attendees
  const { event, isLoading, officeService, updateEvent } = useOfficeItem();

  // indicates the current user is authenticated
  const isAuthenticated = useTokenStore((state) => state.isAuthenticated);

  // indicates the selected organization id
  const selectedOrganizationId = useAddInStore((state) => state.selectedOrganizationId);

  // indicates the selected space id
  const selectedId = useAddInStore((state) => state.selectedSpaceId);

  // used to update the selected space id
  const setSelectedSpaceId = useAddInStore((state) => state.setSelectedSpaceId);

  // indicates the list of sharable spaces
  const [spaces, setSpaces] = useState<Space[]>([]);

  useEffect(() => {
    const loadSpaces = async () => {
      if (!selectedOrganizationId) {
        setSpaces([]);
        return;
      }

      try {
        const response = await supabaseApi.getShareableSpaces(selectedOrganizationId);
        if (response) setSpaces(response);
      } catch (err) {
        logger.error("Error fetching spaces", err);
        setSpaces([]);
      }
    };

    if (isAuthenticated) loadSpaces();
  }, [isAuthenticated, selectedOrganizationId]);

  return (
    <section className={styles.section}>
      <label htmlFor="space-select">Space</label>
      <Select
        id="space-select"
        className={styles.select}
        disabled={disabled}
        defaultValue={selectedId}
        onChange={(e) => setSelectedSpaceId(e.target.value)}
      >
        <option key="empty-space-id" value={undefined} disabled={selectedId !== undefined}>
          Select an existing space
        </option>
        {spaces.map((space) => (
          <option key={space.id} value={space.id}>
            {space.name}
          </option>
        ))}
      </Select>
    </section>
  );
};
